import Title from "@/components/Title/Title";
import { Wysiwyg } from "@/styles/typography";
import React from "react";
import S from "./TwoTextColumns.style";

export interface Props {
  backgroundColor: string;
  title: string;
  column1: {
    text: string;
  };
  column2: {
    text: string;
  };
}

const TwoTextColumns: React.FC<Props> = ({
  backgroundColor,
  title,
  column1,
  column2,
}) => {
  const setBackgroundColor = () => {
    if (backgroundColor === "white") {
      return "white";
    } else if (backgroundColor === "blue") {
      return "#224C5D";
    } else if (backgroundColor === "black") {
      return "#000";
    }
    return "#2F5A50";
  };

  const column = (column: { text: string }) => {
    return (
      <S.Column>
        <Wysiwyg
          color={setBackgroundColor() === "white" ? "#000" : "#fff"}
          dangerouslySetInnerHTML={{ __html: column.text }}
        />
      </S.Column>
    );
  };

  return (
    <div className="main-inner">
      <S.Container backgroundColor={setBackgroundColor()}>
        {title && (
          <S.TitleWrapper>
            <Title
              title={title}
              backgroundColor={backgroundColor}
              fontSize={"h2"}
            />
          </S.TitleWrapper>
        )}
        <S.ColumnWrapper>
          {column1 && column(column1)}
          {column2 && column(column2)}
        </S.ColumnWrapper>
      </S.Container>
    </div>
  );
};

export default TwoTextColumns;
